import {Injectable} from '@angular/core';
import {AmdocsAppsyncClientService} from 'amdocs-core-package';
import {Observable, of} from 'rxjs';
import {catchError, mergeMap, tap} from 'rxjs/operators';
import { CONSTANTS } from '../constants';

@Injectable()
export class SystemNotificationService {
  constructor(private appSyncClient: AmdocsAppsyncClientService) {
  }

  getUserDACNotifications(): Observable<any> {
    const notificationsQuery = `query GetUserDACNotifications {
      getUserDACNotifications {
        sys_id
        sys_updated_on
        u_active
        u_audience
        u_from_date
        u_message
        u_until_date
        u_visible_in
      }
    }`;

    return this.appSyncClient.call(notificationsQuery, 'GetUserDACNotifications', {}).pipe(
      tap(() => {
        // Reset next notification check time (current time + 15 minutes)
        // This happens automatically on every call from any component
        const nextCheckTime = Date.now() + CONSTANTS.NOTIFICATION_POLLING_INTERVAL * 60 * 1000;
        localStorage.setItem(CONSTANTS.STORAGE.notificationNextCheckTime, nextCheckTime.toString());
      }),
      mergeMap((res: any): Observable<any> => {
        return of(res);
      }),
      catchError(err => {
        console.log(err);
        return of({error: err});
      })
    );
  }
}